/****************************************************
 * Module Name:  virtualTeamProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";

export default class VirtualTeamProxy {
  static GetAllVirtualTeam = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/virtualteam",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllVirtualTeamMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/virtualteam/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllVirtualTeamDetail = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/virtualteam/detail",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleVirtualTeam = (virtualTeamId, callback) => {
    let params = {
      id: virtualTeamId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/virtualteam",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckVirtualTeamAvailable = (virtualTeam, callback) => {
    let params = {
      virtualTeam: virtualTeam,
    };

    restAPICall(
      Constants.MANAGER_URL + "/virtualteam/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddVirtualTeam = (virtualTeam, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/virtualteam",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(virtualTeam),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateVirtualTeam = (virtualTeam, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/virtualteam",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(virtualTeam),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllStockReport = (virtualTeam, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/virtualteam/detail",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(virtualTeam),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
